export default __webpack_public_path__ + "static/media/hallway-Mid_Knauf_W112H213EI60_M.fa82ab3c.jpg";